import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import DatePicker from "react-date-picker";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import "../tailwind.css";

export default function Hero() {
  const [step, setStep] = useState(1);
  const [premium, setPremium] = useState(0);
  const [sumAssured, setSumAssured] = useState(0);
  const [coverageAge, setCoverageAge] = useState(0);
    const [otp, setOtp] = useState("");

 
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      dob: "",
      gender: "",
      tobacco: "",
      income: "",
    },
  });

  const dobValue = watch("dob");

  // Age calculation
  const calculateAge = (dobValue) => {
    if (!dobValue) return null;
    const birthDate = new Date(dobValue);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
    return age >= 0 ? age : null;
  };
  const age = calculateAge(dobValue);

  // Options
  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
  ];
  const tobaccoOptions = [
    { value: "Non-Tobacco User", label: "Non-Tobacco User" },
    { value: "Tobacco User", label: "Tobacco User" },
  ];
  const incomeOptions = [
    { value: "0 - 5 Lakhs", label: "0 - 5 Lakhs" },
    { value: "5 - 10 Lakhs", label: "5 - 10 Lakhs" },
    { value: "10 - 15 Lakhs", label: "10 - 15 Lakhs" },
    { value: "15 - 20 Lakhs", label: "15 - 20 Lakhs" },
    { value: "20 - 25 Lakhs", label: "20 - 25 Lakhs" },
    { value: "25 Lakhs+", label: "25 Lakhs+" },
  ];

  const onSubmit = (data) => {
    const { gender, tobacco, income } = data;

    // Map income to numeric
    const incomeMap = {
      "0 - 5 Lakhs": 500000,
      "5 - 10 Lakhs": 1000000,
      "10 - 15 Lakhs": 1500000,
      "15 - 20 Lakhs": 2000000,
      "20 - 25 Lakhs": 2500000,
      "25 Lakhs+": 3000000,
    };
    const incomeNum = incomeMap[income] || 500000;

    const sumAssured = incomeNum * 15;
    const genderFactor = gender === "Male" ? 1.05 : 1;
    const tobaccoFactor = tobacco === "Tobacco User" ? 1.75 : 1;
    const ageFactor = 1 + (age - 25) * 0.02;

    const annualPremium =
      (sumAssured * ageFactor * genderFactor * tobaccoFactor) / 1000;
    const monthlyPremium = Math.round(annualPremium / 12);

    setPremium(monthlyPremium);
    setSumAssured(sumAssured);
    setCoverageAge(60);
    setStep(2);
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    if (otp.length === 6) {
      setStep(3); // move to result step
    } else {
      alert("Please enter 6-digit OTP");
    }
  };

  const handleEdit = () => setStep(1);

  const formatINR = (num) => num.toLocaleString("en-IN");

  return (
    <section className="tw-pt-[120px] tw-pb-[40px] tw-bg-gradient-to-br tw-from-blue-50 tw-via-white tw-to-orange-50 tw-relative tw-overflow-hidden">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-6 tw-flex tw-items-center tw-h-full">
        <div className="tw-grid md:tw-grid-cols-2 tw-gap-12 tw-items-center tw-w-full">
          {/* LEFT SIDE */}
          <div className="tw-space-y-8">
            <div class="space-y-6">
              <h1 className="tw-text-4xl lg:tw-text-6xl tw-font-[600] tw-text-fintoo-blue tw-leading-tight">
                Find the Right Life Insurance Plan —{" "}
                <span className="tw-text-fintoo-orange">
                  With Guidance, Not Sales
                </span>
              </h1>

              <p className="tw-text-base lg:tw-text-xl tw-text-gray-700 tw-leading-relaxed">
                At Fintoo, we compare the best term insurance plans from trusted
                names and help you secure your family’s future with confidence.
              </p>
            </div>
            <div class="tw-flex tw-flex-wrap tw-gap-4">
              <div class="tw-flex tw-items-center tw-bg-white/70 tw-backdrop-blur-sm tw-px-4 tw-py-2 tw-rounded-full tw-border tw-border-solid tw-border-gray-200">
                <i class="fa-solid fa-shield tw-text-fintoo-blue tw-mr-2"></i>
                <span class="tw-text-sm tw-font-medium tw-text-gray-700">Trusted Advisors</span>
              </div>
              <div class="tw-flex tw-items-center tw-bg-white/70 tw-backdrop-blur-sm tw-px-4 tw-py-2 tw-rounded-full tw-border tw-border-solid tw-border-gray-200">
                <i class="fa-solid fa-users tw-text-fintoo-blue tw-mr-2"></i>
                <span class="tw-text-sm tw-font-medium tw-text-gray-700">75,000+ Families Guided</span>
              </div>
              <div class="tw-flex tw-items-center tw-bg-white/70 tw-backdrop-blur-sm tw-px-4 tw-py-2 tw-rounded-full tw-border tw-border-solid tw-border-gray-200">
                <i class="fa-solid fa-handshake tw-text-fintoo-blue tw-mr-2"></i>
                <span class="tw-text-sm tw-font-medium tw-text-gray-700">Free Personalized Assistance</span>
              </div>

            </div>
          </div>

          {/* RIGHT SIDE FORM */}
          <div className="tw-bg-white/80 tw-backdrop-blur-lg tw-rounded-3xl tw-p-8 tw-shadow-2xl tw-border tw-border-gray-200">
            <h3 class="rw-text-2xl tw-font-bold tw-text-fintoo-blue tw-mb-6 tw-text-center">Get Your Premium Calculated</h3>

            {step === 1 && (
              <form
                className="tw-space-y-4 tw-calculatorform"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="tw-grid lg:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <input
                      type="text"
                      placeholder="First Name"
                      {...register("firstName", {
                        required: "First name is required",
                      })}
                      className="tw-w-full tw-px-4 h-[50px] tw-py-3 tw-rounded-xl tw-border tw-border-gray-200 focus:tw-border-fintoo-orange focus:tw-outline-none"
                    />
                    {errors.firstName && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.firstName.message}
                      </p>
                    )}
                  </div>
                  <div>
                    <input
                      type="text"
                      placeholder="Last Name"
                      {...register("lastName", {
                        required: "Last name is required",
                      })}
                      className="tw-w-full tw-px-4  h-[50px] tw-py-3 tw-rounded-xl tw-border tw-border-gray-200 focus:tw-border-fintoo-orange focus:tw-outline-none"
                    />
                    {errors.lastName && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.lastName.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="tw-grid lg:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <Controller
                      name="phone"
                      control={control}
                      rules={{ required: "Phone number is required" }}
                      render={({ field }) => (
                        <PhoneInput
                          {...field}
                          country="in"
                          placeholder="Enter phone number"
                          inputStyle={{
                            width: "100%",
                            background: "none",
                            height: "50px",
                            borderRadius: "12px",
                            border: "1px solid #e5e7eb",
                            paddingLeft: "50px",
                          }}
                          buttonStyle={{ border: "none" }}
                          onChange={(value) => field.onChange(value)}
                        />
                      )}
                    />
                    {errors.phone && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.phone.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <input
                      type="email"
                      placeholder="Email"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Enter valid email",
                        },
                      })}
                      className="tw-w-full tw-px-4  h-[50px] tw-py-3 tw-rounded-xl tw-border tw-border-gray-200 focus:tw-border-fintoo-orange focus:tw-outline-none"
                    />
                    {errors.email && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.email.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="tw-grid lg:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <Controller
                      name="dob"
                      control={control}
                      rules={{
                        required: "Date of Birth is required",
                        validate: (value) => {
                          if (!value) return "Date of Birth is required";
                          const birthDate = new Date(value);
                          const today = new Date();
                          let age = today.getFullYear() - birthDate.getFullYear();
                          const m = today.getMonth() - birthDate.getMonth();
                          if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) age--;
                          return age >= 18 || "You must be at least 18 years old";
                        },
                      }}
                      render={({ field }) => (
                        <div className="tw-insurance">


                          <DatePicker
                            {...field}
                            value={field.value || null} // keep null if empty
                            onChange={(date) => field.onChange(date)}
                            maxDate={new Date()}
                            clearIcon={null}
                            calendarIcon={<i className="fa-solid fa-calendar tw-text-gray-400"></i>} // calendar icon
                            format="dd/MM/yyyy"
                            className="tw-w-full tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 focus:tw-border-fintoo-blue focus:tw-outline-none"
                          />

                        </div>
                      )}
                    />

                    {age !== null && (
                      <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
                        Age: {age} years
                      </p>
                    )}
                    {errors.dob && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.dob.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <Controller
                      name="gender"
                      control={control}
                      rules={{ required: "Gender is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={genderOptions}
                          placeholder="Select Gender"
                          classNames={{
                            control: () =>
                              "!tw-rounded-xl py-1 tw-border-gray-200",
                          }}
                        />
                      )}
                    />
                    {errors.gender && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.gender.message}
                      </p>
                    )}
                  </div>
                </div>

                <div className="tw-grid lg:tw-grid-cols-2 tw-gap-4">
                  <div>
                    <Controller
                      name="tobacco"
                      control={control}
                      rules={{ required: "Tobacco usage is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={tobaccoOptions}
                          placeholder="Tobacco Usage"
                          classNames={{
                            control: () =>
                              "!tw-rounded-xl py-1 tw-border-gray-200",
                          }}
                        />
                      )}
                    />
                    {errors.tobacco && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.tobacco.message}
                      </p>
                    )}
                  </div>

                  <div>
                    <Controller
                      name="income"
                      control={control}
                      rules={{ required: "Annual income is required" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={incomeOptions}
                          placeholder="Annual Income"
                          classNames={{
                            control: () =>
                              "!tw-rounded-xl py-1 tw-border-gray-200",
                          }}
                        />
                      )}
                    />
                    {errors.income && (
                      <p className="tw-text-red-500 tw-text-xs mt-1">
                        {errors.income.message}
                      </p>
                    )}
                  </div>
                </div>
                <div class="tw-flex tw-items-start tw-space-x-3 tw-pt-2">
                  <input type="checkbox" checked class="tw-mt-1 tw-text-fintoo-blue" required />
                  <span class="tw-text-sm tw-text-gray-600">I agree with <a href="#" class="tw-underline tw-text-fintoo-orange">Terms &amp; Conditions</a></span>
                </div>
                <div class="tw-flex tw-items-start tw-space-x-3 tw-pt-2">
                  <input type="checkbox" checked class="tw-mt-1 tw-text-fintoo-blue" />
                  <span class="tw-text-sm tw-text-gray-600">Get Updates on WhatsApp</span>
                </div>

                <button
                  type="submit"
                  className="tw-w-full tw-bg-fintoo-orange tw-text-white tw-py-4 tw-rounded-xl tw-font-bold tw-text-lg hover:tw-shadow-lg tw-transition-all"
                >
                  Calculate My Premium
                </button>
              </form>
            )}



         {step === 2 && (
              <form
                onSubmit={handleOtpSubmit}
                className="tw-space-y-6 tw-text-center"
              >
                <p className="tw-text-gray-700 tw-text-lg">
                  Enter the 6-digit OTP sent to your mobile
                </p>
                <input
                  type="number"
                  maxLength="6"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  className="tw-w-full tw-text-center tw-text-2xl tw-tracking-widest tw-px-4 tw-py-3 tw-rounded-xl tw-border tw-border-gray-300 focus:tw-border-fintoo-orange focus:tw-outline-none"
                  placeholder="______"
                />
                <button
                  type="submit"
                  className="tw-w-full tw-bg-fintoo-orange tw-text-white tw-py-3 tw-rounded-xl tw-font-semibold hover:tw-shadow-lg tw-transition-all"
                >
                  Verify OTP
                </button>
              </form>
            )}

            {/* STEP 3 RESULT */}
            {step === 3 && (
              <div>
                <div className="tw-text-center tw-mb-8">
                  <div className="tw-w-16 tw-h-16 tw-bg-green-100 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
                    <i className="fa-solid fa-check tw-text-green-600 tw-text-2xl"></i>
                  </div>
                  <h3 className="tw-text-2xl tw-font-bold tw-text-fintoo-blue tw-mb-2 tw-pb-0 ">Your Premium Calculated</h3>
                  <p className="tw-text-gray-600">Based on your details, here's your personalized premium</p>
                </div>

                <div className="tw-text-center tw-mb-8 tw-p-6 tw-bg-gradient-to-r tw-from-blue-50 tw-to-orange-50 tw-rounded-2xl">
                  <div className="tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-2">₹<span id="premiumAmount"> {formatINR(premium)}</span>/month</div>
                  <div className="tw-text-sm tw-text-gray-600">Starting Premium</div>
                </div>
                <div className="tw-space-y-4 tw-mb-8">
                  <div className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-border-b tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-gray-100">
                    <span className="tw-text-gray-600">Sum Assured</span>
                    <span className="tw-font-semibold tw-text-fintoo-blue">₹{formatINR(sumAssured)}</span>
                  </div>
                  <div className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-border-b tw-border-solid tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-gray-100">
                    <span className="tw-text-gray-600">Policy Term</span>
                    <span className="tw-font-semibold tw-text-fintoo-blue">30 years</span>
                  </div>
                  <div className="tw-flex tw-justify-between tw-items-center tw-py-2 tw-border-b tw-border-solid  tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-gray-100">
                    <span className="tw-text-gray-600">Premium Frequency</span>
                    <span className="tw-font-semibold tw-text-fintoo-blue">Monthly</span>
                  </div>
                  <div className="tw-flex tw-justify-between tw-items-center tw-py-2">
                    <span className="tw-text-gray-600">Coverage Till Age</span>
                    <span className="tw-font-semibold tw-text-fintoo-blue"><span id="coverageAge">{coverageAge}</span> years</span>
                  </div>
                </div>
                <div className="tw-grid tw-grid-cols-2 tw-gap-4">
                  <button onClick={handleEdit} className="tw-w-full tw-border-2 tw-border-fintoo-blue tw-text-fintoo-blue tw-py-3 tw-rounded-xl tw-font-semibold hover:tw-bg-blue-50 tw-transition-colors">
                    Edit Details
                  </button>
                  <button className="tw-w-full tw-bg-fintoo-orange tw-text-white tw-py-3 tw-rounded-xl tw-font-semibold hover:tw-bg-fintoo-orange tw-transition-colors">
                    Request A Call Back
                  </button>
                </div>

                <p className="tw-mt-4 tw-mb-0 tw-text-gray-500">
                  Disclaimer: Estimated premium only. Actual premium may vary. Consult our insurance advisor for details.*
                </p>

              </div>


            )}
          </div>
        </div>
      </div>
    </section>
  );
}
